import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { withTranslation } from 'react-i18next';
import { ACCOUNT_TYPE } from '../../utils/constants';

function AccountTypeSelector({ input, t, isDisabled, ...rest }) {
  const color = { color: '#646777' };
  const fill = { fill: '#646777' };
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
        className="d-flex w-100"
      >
        <RadioButton
          iconStyle={fill}
          labelStyle={color}
          value={ACCOUNT_TYPE.CURRENT}
          label={t('account.current')}
          disabled={isDisabled}
        />
        <RadioButton
          iconStyle={fill}
          labelStyle={color}
          value={ACCOUNT_TYPE.SAVINGS}
          label={t('account.savings')}
          disabled={isDisabled}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
}

AccountTypeSelector.propTypes = {
  input: PropTypes.shape(PropTypes.shape).isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

AccountTypeSelector.defaultProps = {
  isDisabled: false,
};

export default withTranslation('common')(AccountTypeSelector);
